<script setup lang="ts">
import { VTable } from '@/modules/shared/components'
import { type SearchResult } from '../types'

defineProps<{
  searchResults: SearchResult[]
}>()
</script>

<template>
  <div>
    <div class="flex items-center justify-between rounded-lg border bg-gray-50 p-3 pb-6">
      <p class="block text-xs font-semibold uppercase text-gray-700">Search Results:</p>
      <p class="block text-sm text-gray-700">{{ searchResults.length }} Potential Matches</p>
    </div>
    <div class="-mt-3 rounded-lg bg-white">
      <VTable
        :columns="[
          {
            key: 'data_source.name',
            name: 'Data Source',
            type: 'string',
            is_visible: true,
          },
          {
            key: 'name',
            name: 'Name',
            type: 'string',
            is_visible: true,
          },
          {
            key: 'confidence_score',
            name: 'Confidence Score',
            type: 'percent',
            is_visible: true,
          },
          {
            key: 'entity_type',
            name: 'Entity Type',
            type: 'string',
            is_visible: true,
          },
          {
            key: 'date_of_birth.0',
            name: 'Date of Birth',
            type: 'date',
            is_visible: true,
          },
          {
            key: 'gender',
            name: 'Gender',
            type: 'string',
            is_visible: true,
          },
          {
            key: 'address.0',
            name: 'Address',
            type: 'string',
            is_visible: true,
          },
          {
            key: 'country_residence.0',
            name: 'Country of Residence',
            type: 'string',
            is_visible: true,
          },
          {
            key: 'nationality',
            name: 'Nationality',
            type: 'string',
            is_visible: true,
          },
          {
            key: 'remarks',
            name: 'Remarks',
            type: 'string',
            is_visible: true,
          },
        ]"
        :items="searchResults"
      />
    </div>
  </div>
</template>
